const MAX_LENGTH = 150;

const truncateString = (string = '', maxLength = MAX_LENGTH) =>
  string.length > maxLength
    ? `${string.substring(0, maxLength - 3)}...`
    : string;

export default truncateString;
